

























































import { Component, Vue } from "vue-property-decorator";
import { ReferralInfo } from "@foxone/api/src/models/foxone";
import { State } from "vuex-class";
import ReferralSetSuccessModal from "./ReferralSetSuccessModal.vue";

@Component({
  components: {
    ReferralSetSuccessModal
  }
})
class Inviter extends Vue {
  @State(state => state.basis.account.referral) referral!: ReferralInfo;

  code = "";

  setting = false;

  successModal = false;

  get inviter() {
    return this.referral.inviter;
  }

  get meta() {
    const inviter = this.referral.inviter;
    if (!inviter) {
      return {};
    }
    return {
      avatar: inviter.avatar || require("@/assets/images/default_avatar.png"),
      name: inviter.fullname,
      time: this.$common.utils.date.formatDate(inviter.created_at)
    };
  }

  get disabled() {
    return !this.code;
  }

  async requestSetReferralCode() {
    this.setting = true;
    try {
      await this.$api.foxone.putReferralCode(this.code);
      await this.$store.dispatch("basis/account/loadAccountData");
      this.successModal = true;
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.setting = false;
  }
}
export default Inviter;
